import { render, staticRenderFns } from "./Wiki.vue?vue&type=template&id=7fce19c6&scoped=true&"
import script from "./Wiki.vue?vue&type=script&lang=js&"
export * from "./Wiki.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fce19c6",
  null
  
)

export default component.exports